// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"Login_linkWrapper__W_C1V","link":"Login_link__1qcNU","btn":"Login_btn__21_-T","form":"Login_form__16FSP","fields":"Login_fields__3AC4m"};